import services from 'services/module';

const jq = _.once(() => $.noConflict());

class PaymentHelpers {
    cardExpiryVal = (value: string) => jq().payment.cardExpiryVal(value);

    validateCardNumber = (num: string) => jq().payment.validateCardNumber(num);

    validateCardExpiry(value: string) {
        const exp = jq().payment.cardExpiryVal(value);
        return jq().payment.validateCardExpiry(exp.month.toString(), exp.year.toString());
    };

    validateCardCvc = (cvc: string, type: string) => jq().payment.validateCardCVC(cvc, type);

    restrictNumeric = (element: HTMLElement) => jq()(element).payment('restrictNumeric');

    formatCardCvc = (element: HTMLElement) => jq()(element).payment('formatCardCVC');

    formatCardExpiry = (element: HTMLElement) => jq()(element).payment('formatCardExpiry');

    formatCardNumber = (element: HTMLElement) => jq()(element).payment('formatCardNumber');
}
services.factory('PaymentHelpers', () => new PaymentHelpers());



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/PaymentHelpers.ts